"use client";

import type { DefinedQueryObserverResult } from "@tanstack/react-query";
import { type Atom, useStore } from "jotai";
import { useEffect } from "react";

type PromiseOrValue<T> = Promise<T> | T;

export function useRefetchAtom(
  atom: Atom<PromiseOrValue<DefinedQueryObserverResult<unknown, unknown>>>,
): void {
  const store = useStore();
  useEffect(() => {
    Promise.resolve(store.get(atom)).then((result) => {
      result.refetch();
    });
  }, [atom, store]);
}
